module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-support-iStock-1280247430.0cad4307.jpg";